import { Controller } from 'stimulus';
import TomSelect from 'tom-select';

class TomSelectController extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ['remove_button'],
      create: false,
      persist: false,
      hidePlaceholder: true,
      allowEmptyOption: true,
    });
  }

  clear() {
    this.select.clear();
  }
}

TomSelectController.targets = [];

export default TomSelectController;
